export const DATE_FORMAT = 'DD-MM-YYYY'

// InPost statuses
// const PARCEL_STATUS_CREATED = 'created'
const PARCEL_STATUS_PREPARED = 'prepared'
export const PARCEL_STATUS_INTRANSIT = 'in_transit'
const PARCEL_STATUS_STORED = 'stored'

const PARCEL_STATUS_EXPIRED = 'expired'

const PARCEL_STATUS_RETURNEDTOSENDER = 'returnedToSender'
const PARCEL_STATUS_RETURNEDTOAGENCY = 'retuned_to_agency'
// const PARCEL_STATUS_DELIVERED = 'delivered'

// Shipx statuses
const PARCEL_STATUS_CREATED = "created";
const PARCEL_STATUS_CONFIRMED = "confirmed";
const PARCEL_STATUS_DISPATCHED_BY_SENDER = "dispatched_by_sender";
const PARCEL_STATUS_TAKEN_BY_COURIER = "taken_by_courier";
const PARCEL_STATUS_ADOPTED_AT_SOURCE_BRANCH = "adopted_at_source_branch";
const PARCEL_STATUS_SENT_FROM_SOURCE_BRANCH = "sent_from_source_branch";
const PARCEL_STATUS_ADOPTED_AT_SORTING_CENTER = "adopted_at_sorting_center";
const PARCEL_STATUS_SENT_FROM_SORTING_CENTER = "sent_from_sorting_center";
const PARCEL_STATUS_ADOPTED_AT_TARGET_BRANCH = "adopted_at_target_branch";
export const PARCEL_STATUS_OUT_FOR_DELIVERY = "out_for_delivery";
const PARCEL_STATUS_READY_TO_PICKUP = "ready_to_pickup";
const PARCEL_STATUS_DELIVERED = "delivered";
const PARCEL_STATUS_PICKUP_REMINDER_SENT = "pickup_reminder_sent";
const PARCEL_STATUS_MISSING = "missing";

const PARCEL_STATUS_PICKUP_TIME_EXPIRED = "pickup_time_expired";

const PARCEL_STATUS_CLAIMED = "claimed";
const PARCEL_STATUS_RETURNED_TO_SENDER = "returned_to_sender";
const PARCEL_STATUS_OTHER = "other";
const PARCEL_STATUS_OVERSIZED = "oversized";
const PARCEL_STATUS_HANDED_OVER = "handed_over";
const PARCEL_STATUS_RETURNED_TO_AGENCY = "returned_to_agency";
const PARCEL_STATUS_CANCELED = "canceled";
const PARCEL_STATUS_COLLECTED_FROM_SENDER = "collected_from_sender";

export const PARCEL_STATUS_CANCELLED = 'cancelled'

export const PARCEL_LIST_TYPE_ACTIVE = 'active'
export const PARCEL_LIST_TYPE_EXPIRED = 'expired'
export const PARCEL_LIST_TYPE_ARCHIVE = 'archive'

export const parcelListTypes = {
  [PARCEL_LIST_TYPE_ACTIVE]: [
    PARCEL_STATUS_CREATED,
    PARCEL_STATUS_PREPARED,
    PARCEL_STATUS_INTRANSIT,
    PARCEL_STATUS_STORED,
    PARCEL_STATUS_CONFIRMED,
    PARCEL_STATUS_DISPATCHED_BY_SENDER,
    PARCEL_STATUS_TAKEN_BY_COURIER,
    PARCEL_STATUS_ADOPTED_AT_SOURCE_BRANCH,
    PARCEL_STATUS_SENT_FROM_SOURCE_BRANCH,
    PARCEL_STATUS_ADOPTED_AT_SORTING_CENTER,
    PARCEL_STATUS_SENT_FROM_SORTING_CENTER,
    PARCEL_STATUS_ADOPTED_AT_TARGET_BRANCH,
    PARCEL_STATUS_OUT_FOR_DELIVERY,
    PARCEL_STATUS_READY_TO_PICKUP,
    PARCEL_STATUS_DELIVERED,
    PARCEL_STATUS_PICKUP_REMINDER_SENT,
    PARCEL_STATUS_MISSING,
  ],
  [PARCEL_LIST_TYPE_EXPIRED]: [
    PARCEL_STATUS_EXPIRED,
    PARCEL_STATUS_PICKUP_TIME_EXPIRED,
  ],
  [PARCEL_LIST_TYPE_ARCHIVE]: [
    PARCEL_STATUS_RETURNEDTOSENDER,
    PARCEL_STATUS_RETURNEDTOAGENCY,
    // PARCEL_STATUS_DELIVERED,
    PARCEL_STATUS_CANCELLED,
    PARCEL_STATUS_CLAIMED,
    PARCEL_STATUS_RETURNED_TO_SENDER,
    PARCEL_STATUS_OTHER,
    PARCEL_STATUS_OVERSIZED,
    PARCEL_STATUS_HANDED_OVER,
    PARCEL_STATUS_RETURNED_TO_AGENCY,
    PARCEL_STATUS_CANCELED,
    PARCEL_STATUS_COLLECTED_FROM_SENDER,
  ],
}
